// 是否应该显示复制按钮
const noNeedCopyColumnKeys = ['qrcode'];
export function isShowCopyButton(props) {
  return !noNeedCopyColumnKeys.includes(props.columnKey);
}
